import React from "react";

export default function EtherealFog() {
  return (
    <div className="ethereal-fog pointer-events-none">
      <div className="fog-layer layer1"></div>
      <div className="fog-layer layer2"></div>
      {/* <div className="fog-layer layer3"></div> */}
    </div>
  );
}
